module.exports = __webpack_public_path__ + "static/media/medicare-guide-2025.2e853b97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medicare-guide-2025.png
// module id = 239
// module chunks = 0